import schools from "./schools.json";
import schools_macau from "./schools_macau.json";

// append wildcard
schools.unshift("其他");

export default schools
  .concat(schools_macau)
  .map((school, idx) => ({ value: idx, label: school }));
